import { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { generatePath, useNavigate } from 'react-router-dom'
import { Button, Modal, Radio, Space, Typography, notification } from 'antd'
import * as icons from '@ant-design/icons'

import * as ROUTES from 'admin/routes'
import { useCompanyByIds, useCompanyMerge } from 'admin/lib/Api/queries'

export function CompanyListMergeModal({
  open = false,
  onClose = () => {},
  companyIds = []
}) {
  const navigate = useNavigate()

  const [targetId, setTargetId] = useState(null)

  const refCompanies = useCompanyByIds(companyIds)
  const merge = useCompanyMerge()

  const handleApply = useCallback(async () => {
    const otherIds = companyIds.filter(id => id !== targetId)

    try {
      await merge.mutateAsync({
        targetCompanyId: targetId,
        otherCompanyIds: otherIds
      })

      notification.success({
        message: 'Companies merged successfully! 🙌'
      })

      navigate(generatePath(ROUTES.COMPANIES.EDIT, { companyId: targetId }))
    } catch (e) {
      notification.error({
        message:
          'Merge failed 😦. ' +
          e?.response.status +
          ': ' +
          String(e?.response.data)
      })
    }
  }, [companyIds, targetId, merge, navigate])

  return (
    <Modal
      open={open}
      closable
      onCancel={onClose}
      maskClosable
      footer={null}
      title="Which company do you want to keep?"
    >
      <Space direction="vertical">
        {(refCompanies.isFetching || merge.isLoading) && (
          <icons.LoadingOutlined />
        )}

        {!refCompanies.isFetching && !merge.isLoading && (
          <Radio.Group onChange={e => setTargetId(e.target.value)}>
            {refCompanies.data.map(refComp => {
              return (
                <Radio
                  style={{ display: 'block' }}
                  key={refComp.companyId}
                  value={refComp.companyId}
                >
                  {refComp.name}
                </Radio>
              )
            })}
          </Radio.Group>
        )}

        <Typography.Text>
          All certificates and reference products from the rest will be merged
          on to the selected company.
        </Typography.Text>

        <Button
          type="primary"
          disabled={!refCompanies.isFetched || merge.isLoading || !targetId}
          onClick={handleApply}
        >
          Apply Merge
        </Button>
      </Space>
    </Modal>
  )
}

CompanyListMergeModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyIds: PropTypes.arrayOf(PropTypes.string).isRequired
}
